module.exports = __webpack_public_path__ + "img/lecture.bc658b03.svg";